import { SurveyStatusType } from "src/constants/survey";
import { EnumSurveyType, EnumUserGroup } from "../components/Enums";

export type SurveyQuestionUpdate = {
    uuid: string;
    question: string;
    questionOrder: number;
    surveyType: string;
};

export type SurveyUpdateSource = {
    name: string;
    surveyType: string;
    startDate: string;
    finishDate: string;
    userGroup: string;
    surveyQuestions: SurveyQuestionUpdate[];
    showIn: string;
    showFrequency: string;
    isAnonymous: boolean;
    status: string;
};

export type SurveyUpdatePayload = {
    name: string;
    surveyType: string;
    startDate: string | null;
    finishDate: string | null;
    userGroup: string;
    surveyQuestions: SurveyQuestionUpdate[];
    imageUrl: string;
    showIn: string;
    showFrequency: string;
    isAnonymous: boolean;
    selectedUsers?: string[];
};

const formatDate = (date: string): string => {
    return Intl.DateTimeFormat("fr-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }).format(new Date(date));
};

export const buildSurveyUpdatePayload = (
    survey: SurveyUpdateSource,
    originalSurvey: SurveyUpdateSource,
    selectedUsers: string[],
    imageUrl: string
): SurveyUpdatePayload => {
    const isActiveSurvey = originalSurvey.status === SurveyStatusType.ACTIVE;
    const startDate = isActiveSurvey ? originalSurvey.startDate : survey.startDate;
    const surveyType = isActiveSurvey ? originalSurvey.surveyType : survey.surveyType;
    const surveyQuestions = isActiveSurvey ? originalSurvey.surveyQuestions : survey.surveyQuestions;

    const payload: SurveyUpdatePayload = {
        name: survey.name,
        surveyType,
        startDate: startDate ? `${formatDate(startDate)} 00:00:00` : null,
        finishDate: survey.finishDate ? `${formatDate(survey.finishDate)} 23:59:59` : null,
        userGroup: survey.userGroup,
        surveyQuestions: surveyQuestions.map(question => ({
            uuid: question.uuid,
            question: question.question,
            questionOrder: question.questionOrder,
            surveyType: surveyType === EnumSurveyType.MULTI_TYPE ? question.surveyType : surveyType
        })),
        imageUrl,
        showIn: survey.showIn,
        showFrequency: survey.showFrequency,
        isAnonymous: isActiveSurvey ? originalSurvey.isAnonymous : survey.isAnonymous
    };

    if (survey.userGroup === EnumUserGroup.SELECTED_USERS) {
        payload.selectedUsers = selectedUsers;
    }

    return payload;
};
